import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { ArrowSquareOutIcon } from '@phosphor-icons/react'

import { Card, CardTitle, Divider, Link } from '@reveni-io/reveni-ui'

import CustomerDetailInfo from '@/common/components/CustomerDetailInfo/CustomerDetailInfo.jsx'
import AppContext from '@/common/context/app.context.js'

import * as Styles from './styles.js'

const OriginalPurchaseDetailCard = ({ orderDate, externalUrl, orderNumber, fromExchangeOrder, customer }) => {
  const { t, i18n } = useTranslation()
  const { info } = useContext(AppContext)

  return (
    <Card showBorder={false}>
      <CardTitle>{t('Pedido original')}</CardTitle>
      <Styles.MainContainer>
        <Styles.Container>
          <Styles.Info>
            <label>{t('Compra original')}</label>
            {externalUrl && (
              <Link href={externalUrl} target="_blank" rel="noreferrer">
                {orderNumber} <ArrowSquareOutIcon size={24} />
              </Link>
            )}
            {!externalUrl && <p>{orderNumber}</p>}
          </Styles.Info>
          <Styles.Info>
            <label>{t('Fecha compra')}</label>
            <p>
              {orderDate &&
                new Intl.DateTimeFormat(i18n.language, {
                  dateStyle: 'medium',
                  timeZone: info?.selectedStore?.timezone,
                }).format(new Date(orderDate))}
            </p>
          </Styles.Info>
        </Styles.Container>
        {customer && (
          <CustomerDetailInfo
            nameLabel="Nombre del comprador"
            customerProfile={{ first_name: customer.name, email: customer.email, phone: customer.phone }}
          />
        )}
        {fromExchangeOrder?.id && (
          <>
            <Divider />
            <Styles.Container>
              <Styles.Info>
                <label>{t('Número del cambio anterior')}</label>
                <Link href={fromExchangeOrder?.returnUrl} target="_blank" rel="noreferrer">
                  {fromExchangeOrder?.name} <ArrowSquareOutIcon size={24} />
                </Link>
              </Styles.Info>
              <Styles.Info>
                <label>{t('Fecha del cambio anterior')}</label>
                <p>
                  {new Intl.DateTimeFormat(i18n.language, {
                    dateStyle: 'medium',
                    timeZone: info?.selectedStore?.timezone,
                  }).format(new Date(fromExchangeOrder?.date))}
                </p>
              </Styles.Info>
            </Styles.Container>
          </>
        )}
      </Styles.MainContainer>
    </Card>
  )
}

export default OriginalPurchaseDetailCard
